import { getPublicProfiles } from '@homeservices/api-kit/search/publicprofile';
import { createPublicProfile } from '@/transformations/public-profile';

export default {
  state () {
    return {
      profiles: {},
      meta: {},
    };
  },
  getters: {
    getPublicProfile: state => (id) => {
      return state.profiles[id];
    },
    getPublicProfileLoading: state => (id) => {
      const profileMeta = state.meta[id];
      return profileMeta && profileMeta.loading;
    },
  },
  actions: {
    async fetchPublicProfile ({ commit }, { ids }) {
      try {
        commit('updatePublicProfileMeta', { id: ids, loading: true });
        const response = await getPublicProfiles({ ids });
        commit('addPublicProfile', { profile: response.data.results[0] });
        return response;
      } catch (err) {
        commit('updatePublicProfileMeta', { id: ids, loading: false });
        return err;
      }
    },
  },
  mutations: {
    updatePublicProfileMeta (state, { id, loading }) {
      state.meta = {
        ...state.meta,
        [id]: {
          ...state.meta[id],
          loading,
        },
      };
    },
    addPublicProfile (state, { profile }) {
      state.profiles = {
        ...state.profiles,
        [profile.id]: createPublicProfile(profile),
      };
    },
  },
};
